import React, { useContext, useEffect, useState } from 'react';
import './activationFonctionnalites.scss';
import AppelerApi from '../../../services/appeler-api.service';
import { Box, Button, Checkbox, Modal, TextField } from '@mui/material';
import AnnulerIcone from '@mui/icons-material/Undo';
import InfoIcone from '@mui/icons-material/Info';
import AjouterIcone from '@mui/icons-material/AddBox';
import FlecheDroite from '@mui/icons-material/KeyboardDoubleArrowRight';
import FlecheBas from '@mui/icons-material/KeyboardDoubleArrowDown';
import Select from 'react-select';
import debounce from 'lodash.debounce'
import { baseSelectionneeContext } from '../../../App';

const ActivationFonctionnalites = () => {

    const { baseSelectionnee } = useContext(baseSelectionneeContext);
    const [valeurEntree, _] = useState('');
    let [flagsSalon, setFlagsSalon] = useState([]);
    let [flagsAdmin, setFlagsAdmin] = useState([]);
    let [modelesSalon, setModelesSalon] = useState([]);
    let [modelesAdmin, setModelesAdmin] = useState([]);
    let [blocSalonOuvert, ouvrirBlocSalon] = useState(false);
    let [blocAdminOuvert, ouvrirBlocAdmin] = useState(false);
    let [optionsModelesSalon, setOptionsModelesSalon] = useState([]);
    let [optionsModelesAdmin, setOptionsModelesAdmin] = useState([]);
    let [salons, setSalons] = useState([]);
    let [admins, setAdmins] = useState([]);
    let [groupes, setGroupes] = useState([]);
    let [notesFlagOuvertes, setNotesFlagOuvertes] = useState({});
    let [nouveauSalonOuvert, ouvrirNouveauSalon] = useState(false);
    let [optionsSelects, setOptionsSelects] = useState({});
    let saisieNotes = '';
    let [saisieNouveauSalonLogin, setNouveauSalonLogin] = useState('');
    let [saisieNouveauSalonModele, setNouveauSalonModele] = useState({});

    const listeCriteresSalon = [{ value: 'LOGIN', label: 'Salons par login' }, { value: 'FLAG', label: 'Salons par flag défini' }, { value: 'DEMO', label: 'Salons démo ou test' },
        { value: 'DANS_ADMIN', label: 'Salons ayant un admin' }, { value: 'GROUPE', label: 'Salons par groupe' }, { value: 'MODELE', label: 'Salons par modèle' }];
    const listeCriteresAdmin = [{ value: 'LOGIN', label: 'Admins par login' }, { value: 'FLAG', label: 'Admins par flag défini' },
        { value: 'ADMIN', label: 'Tous comptes admin' }, { value: 'MODELE', label: 'Admins par modèle' }];
    const [listeFlagsSalon, setListeFlagsSalon] = useState([]);
    const [listeFlagsAdmin, setListeFlagsAdmin] = useState([]);
    let [critereSalon, setCritereSalon] = useState(listeCriteresSalon[0]);
    let [critereAdmin, setCritereAdmin] = useState(listeCriteresAdmin[0]);

    const activerFonctionnaliteModele = (index, flag, admin = false) => {
        let modeleModifie
        if (admin) {
            modeleModifie = JSON.parse(JSON.stringify(modelesAdmin[index]));
            modeleModifie[flag] = !modeleModifie[flag] ? 1 : 0;
            const nouvelleListe = Object.assign([ ...modelesAdmin], { [index]: modeleModifie });
            setModelesAdmin(nouvelleListe);
        } else {
            modeleModifie = JSON.parse(JSON.stringify(modelesSalon[index]));
            modeleModifie[flag] = !modeleModifie[flag] ? 1 : 0;
            const nouvelleListe = Object.assign([ ...modelesSalon], { [index]: modeleModifie });
            setModelesSalon(nouvelleListe);
        }
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: modeleModifie.ID_Enseigne, flag: flag, valeur: modeleModifie[flag] }).then(() => {});
    };

    const modifierSelectFonctionnaliteModele = (index, flag, option, admin = false) => {
        let modeleModifie;
        if (admin) {
            modeleModifie = JSON.parse(JSON.stringify(modelesAdmin[index]));
            modeleModifie[flag] = option.value;
            const nouvelleListe = Object.assign([ ...modelesAdmin], { [index]: modeleModifie });
            setModelesAdmin(nouvelleListe);
        } else {
            modeleModifie = JSON.parse(JSON.stringify(modelesSalon[index]));
            modeleModifie[flag] = option.value;
            const nouvelleListe = Object.assign([ ...modelesSalon], { [index]: modeleModifie });
            setModelesSalon(nouvelleListe);
        }
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: modeleModifie.ID_Enseigne, flag: flag, valeur: modeleModifie[flag] }).then(() => {});
    };

    const activerFonctionnaliteSalon = (index, flag) => {
        const salonModifie = JSON.parse(JSON.stringify(salons[index]));
        salonModifie[flag] = !salonModifie[flag] ? 1 : 0;
        const nouvelleListe = Object.assign([ ...salons], { [index]: salonModifie });
        setSalons(nouvelleListe);
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: salonModifie.ID_Enseigne, flag: flag, valeur: salonModifie[flag] }).then(() => {});
    };

    const modifierSelectFonctionnaliteSalon = (index, flag, option) => {
        const salonModifie = JSON.parse(JSON.stringify(salons[index]));
        salonModifie[flag] = option.value;
        const nouvelleListe = Object.assign([ ...salons], { [index]: salonModifie });
        setSalons(nouvelleListe);
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: salonModifie.ID_Enseigne, flag: flag, valeur: salonModifie[flag] }).then(() => {});
    };

    const retourFlagModeleSalon = (index, flag) => {
        const salonModifie = JSON.parse(JSON.stringify(salons[index]));
        delete salonModifie[flag];
        const nouvelleListe = Object.assign([ ...salons], { [index]: salonModifie });
        setSalons(nouvelleListe);
        AppelerApi.post('/supprimer-feature-flag-actif', { enseigne: salons[index].ID_Enseigne, flag: flag }).then(() => {});
    };

    const activerFonctionnaliteAdmin = (index, flag) => {
        const adminModifie = JSON.parse(JSON.stringify(admins[index]));
        adminModifie[flag] = !adminModifie[flag] ? 1 : 0;
        const nouvelleListe = Object.assign([ ...admins], { [index]: adminModifie });
        setAdmins(nouvelleListe);
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: adminModifie.ID_Enseigne, flag: flag, valeur: adminModifie[flag] }).then(() => {});
    };

    const modifierSelectFonctionnaliteAdmin = (index, flag, option) => {
        const adminModifie = JSON.parse(JSON.stringify(admins[index]));
        adminModifie[flag] = option.value;
        const nouvelleListe = Object.assign([ ...admins], { [index]: adminModifie });
        setAdmins(nouvelleListe);
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: adminModifie.ID_Enseigne, flag: flag, valeur: adminModifie[flag] }).then(() => {});
    };

    const retourFlagModeleAdmin = (index, flag) => {
        const adminModifie = JSON.parse(JSON.stringify(admins[index]));
        delete adminModifie[flag];
        const nouvelleListe = Object.assign([ ...admins], { [index]: adminModifie });
        setAdmins(nouvelleListe);
        AppelerApi.post('/supprimer-feature-flag-actif', { enseigne: admins[index].ID_Enseigne, flag: flag }).then(() => {});
    };

    const afficherNotes = (flagObject) => {
        saisieNotes = flagObject.Notes ?? '';
        setNotesFlagOuvertes(flagObject);
    };

    const masquerNotes = () => {
        setNotesFlagOuvertes({});
    };

    const enregistrerNotes = () => {
        const flagModifie = JSON.parse(JSON.stringify(notesFlagOuvertes));
        flagModifie.Notes = saisieNotes;
        const index = flagsSalon.findIndex(flag => flag.Flag === flagModifie.Flag);
        const nouvelleListe = Object.assign([ ...flagsSalon], { [index]: flagModifie });
        setFlagsSalon(nouvelleListe);
        AppelerApi.post('/modifier-notes-feature-flag', { flag: notesFlagOuvertes.Flag, notes: saisieNotes }).then(() => {});
        masquerNotes();
    };

    const enregistrerNouveauSalon = () => {
        AppelerApi.post('/creer-feature-flag-enseigne', { enseigne: saisieNouveauSalonLogin, modele: saisieNouveauSalonModele.value }).then(() => {
            modifierCritereSalon(listeCriteresSalon[0]);
            rechercheParChaineSalon(saisieNouveauSalonLogin, listeCriteresSalon[0]);
        });
        ouvrirNouveauSalon(false);
    };

    const modifierModeleSalon = (index, optionModele) => {
        const salonModifie = JSON.parse(JSON.stringify(salons[index]));
        salonModifie.Modele = optionModele.value;
        const nouvelleListe = Object.assign([ ...salons], { [index]: salonModifie });
        setSalons(nouvelleListe);
        AppelerApi.post('/modifier-modele-enseigne', { enseigne: salonModifie.ID_Enseigne, modele: salonModifie.Modele }).then(() => {});
    };

    const modifierModeleAdmin = (index, optionModele) => {
        const salonModifie = JSON.parse(JSON.stringify(admins[index]));
        salonModifie.Modele = optionModele.value;
        const nouvelleListe = Object.assign([ ...admins], { [index]: salonModifie });
        setAdmins(nouvelleListe);
        AppelerApi.post('/modifier-modele-enseigne', { enseigne: salonModifie.ID_Enseigne, modele: salonModifie.Modele }).then(() => {});
    };

    const modifierCritereSalon = (critere) => {
        setCritereSalon(critere);
        chercherSalon(critere); // Pour critères sans filtre associé
        if (critere.value === 'GROUPE') {
            AppelerApi.get('/lire-groupes').then(data => {
                setGroupes(data.groupes.map(groupe => { return { value: groupe.IDGroupe, label: groupe.Nom } }));
            });
        }
    };

    const modifierCritereAdmin = (critere) => {
        setCritereAdmin(critere);
        chercherSalon(critere, null, true); // Pour critères sans filtre associé
    };

    const rechercheParChaineSalon = debounce((chaine, critereOptionnel) => {
        chercherSalon(critereOptionnel ?? critereSalon, chaine);
    }, 500);

    const rechercheParChaineAdmin = debounce((chaine, critereOptionnel) => {
        chercherSalon(critereOptionnel ?? critereAdmin, chaine, true);
    }, 500);

    const chercherSalon = (critere, valeurFiltre, admin = false) => {
        switch (critere.value) {
            case 'LOGIN':
                if (!valeurFiltre || valeurFiltre.length < 3) {
                    return;
                }
                AppelerApi.get('/lire-salons-par-enseigne', { enseigne: valeurFiltre, flagsPermanents: true, admin }).then(data => {
                    if (admin) {
                        setAdmins(data.salons);
                    } else {
                        setSalons(data.salons);
                    }
                });
                return;
            case 'FLAG':
                if (!valeurFiltre) {
                    return;
                }
                AppelerApi.get('/lire-salons-par-feature-flag-actif', { flag: valeurFiltre.value, flagsPermanents: true, admin }).then(data => {
                    if (admin) {
                        setAdmins(data.salons);
                    } else {
                        setSalons(data.salons);
                    }
                });
                return;
            case 'DEMO':
                AppelerApi.get('/lire-salons-demo', { flagsPermanents: true, admin }).then(data => {
                    if (admin) {
                        setAdmins(data.salons);
                    } else {
                        setSalons(data.salons);
                    }
                });
                return;
            case 'DANS_ADMIN':
                AppelerApi.get('/lire-salons-dans-admin', { flagsPermanents: true, admin }).then(data => {
                    if (admin) {
                        setAdmins(data.salons);
                    } else {
                        setSalons(data.salons);
                    }
                });
                return;
            case 'ADMIN':
                AppelerApi.get('/lire-admins-ff', { flagsPermanents: true, admin }).then(data => {
                    if (admin) {
                        setAdmins(data.salons);
                    } else {
                        setSalons(data.salons);
                    }
                });
                return;
            case 'GROUPE':
                if (!valeurFiltre) {
                    return;
                }
                AppelerApi.get('/lire-salons-par-groupe', { IDGroupe: valeurFiltre.value, flagsPermanents: true, admin }).then(data => {
                    if (admin) {
                        setAdmins(data.salons);
                    } else {
                        setSalons(data.salons);
                    }
                });
                return;
            case 'MODELE':
                if (!valeurFiltre) {
                    return;
                }
                AppelerApi.get('/lire-salons-par-modele', { modele: valeurFiltre.value, flagsPermanents: true, admin }).then(data => {
                    if (admin) {
                        setAdmins(data.salons);
                    } else {
                        setSalons(data.salons);
                    }
                });
                return;
        }
    };

    useEffect(() => {
        AppelerApi.get('/lire-feature-flags-modeles', { flagsPermanents: true }).then(data => {
            for (const flag of data.flags) {
                if (flag.Valeurs_Proposees) {
                    flag.Valeurs_Proposees = JSON.parse(flag.Valeurs_Proposees);
                    const nouvellesOptions = {};
                    nouvellesOptions[flag.Flag] = Object.entries(flag.Valeurs_Proposees).map(([valeur, texte]) => { return { value: valeur, label: texte }});
                    setOptionsSelects(optionsPrecedentes => { return {...optionsPrecedentes, ...nouvellesOptions }; });
                }
            }
            setFlagsSalon(data.flags.filter(flag => !flag.Admin));
            setFlagsAdmin(data.flags.filter(flag => flag.Admin));
            const listeFlagsSalon = [];
            const listeFlagsAdmin = [];
            for (const flag of data.flags) {
                if (flag.Admin) {
                    listeFlagsAdmin.push({ value: flag.Flag, label: flag.Flag });
                } else {
                    listeFlagsSalon.push({ value: flag.Flag, label: flag.Flag });
                }
            }
            setListeFlagsSalon(listeFlagsSalon);
            setListeFlagsAdmin(listeFlagsAdmin);
            setModelesSalon(data.modeles.filter(modele => !modele.Admin));
            setModelesAdmin(data.modeles.filter(modele => modele.Admin));
            const optionsModelesSalon = [];
            const optionsModelesAdmin = [];
            for (const modele of data.modeles) {
                if (modele.Admin) {
                    optionsModelesAdmin.push({ value: modele.ID_Enseigne, label: modele.Nom_Modele });
                } else {
                    optionsModelesSalon.push({ value: modele.ID_Enseigne, label: modele.Nom_Modele });
                }
            }
            setOptionsModelesSalon(optionsModelesSalon);
            setOptionsModelesAdmin(optionsModelesAdmin);
        });
    }, [valeurEntree, baseSelectionnee]);
    return (
        <div className="conteneur-activationFonctionnalites">
            <h1>Activation de fonctionnalités</h1>
            <div className={blocSalonOuvert ? 'bloc-fonctionnalites' : 'bloc-fonctionnalites ferme'}>
                <div className="ouvrir-fermer">
                    {!blocSalonOuvert && <FlecheDroite className="fleche" onClick={() => ouvrirBlocSalon(true)}></FlecheDroite>}
                    {blocSalonOuvert && <FlecheBas className="fleche" onClick={() => ouvrirBlocSalon(false)}></FlecheBas>}
                    Fonctionnalités salon
                </div>
                <div className="bloc-fonctionnel">
                    <h2>Fonctionnalités des modèles de salons</h2>
                    {
                    flagsSalon.length > 0 &&
                    (<div className="tableau-flags"><table>
                        <thead>
                            <tr>
                                <th scope="col">Modèle</th>
                                {flagsSalon.map(flag => (
                                    <th key={flag.Flag} className="nom-flag" title={flag.Nom}>
                                        {flag.Flag}
                                        <InfoIcone className={flag.Notes ? 'notes' : 'notes note-absente'} onClick={e => afficherNotes(flag)}/>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(modelesSalon).map(([index, modele]) =>
                                <tr key={modele.ID_Enseigne} className="ligne-activation">
                                    <td>{modele.Nom_Modele}</td>
                                    {flagsSalon.map(flag => (
                                        <td key={modele.ID_Enseigne + '_' + flag.Flag} className="cellule-activation">
                                            { (flag.Valeurs_Proposees &&
                                                <Select
                                                    value={optionsSelects[flag.Flag].find(option => option.value == modele[flag.Flag])}
                                                    options={optionsSelects[flag.Flag]}
                                                    onChange={e => modifierSelectFonctionnaliteModele(index, flag.Flag, e)}
                                                    className={(modele[flag.Flag] === undefined) ? 'flag-manquant flag-select' : 'flag-select'}
                                                />
                                            ) || (!flag.Valeurs_Proposees &&
                                                <Checkbox
                                                    checked={!!modele[flag.Flag]}
                                                    onChange={e => activerFonctionnaliteModele(index, flag.Flag, false)}
                                                    className={(modele[flag.Flag] === undefined) ? 'flag-manquant' : ''}
                                                />
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            )}
                        </tbody>
                    </table></div>)
                    }
                </div>
                <div className="bloc-fonctionnel">
                    <h2>Fonctionnalités des salons individuels <AjouterIcone className="ajouter-salon" onClick={_ => ouvrirNouveauSalon(true)}/></h2>
                    <div className="recherche-salon">
                        <h3>Recherche</h3>
                        <Select
                            placeholder="Critère"
                            value={critereSalon}
                            options={listeCriteresSalon}
                            onChange={modifierCritereSalon}
                            className="taille-input"
                        />
                        { (critereSalon.value === 'LOGIN') &&
                            <TextField onChange={event => rechercheParChaineSalon(event.target.value)} className="taille-input"/>
                        }
                        { (critereSalon.value === 'FLAG') &&
                            <Select
                                options={listeFlagsSalon}
                                onChange={e => chercherSalon(critereSalon, e)}
                                className="taille-input"
                            />
                        }
                        { (critereSalon.value === 'GROUPE') &&
                            <Select
                                options={groupes}
                                onChange={e => chercherSalon(critereSalon, e)}
                                className="taille-input"
                            />
                        }
                        { (critereSalon.value === 'MODELE') &&
                            <Select
                                options={optionsModelesSalon}
                                onChange={e => chercherSalon(critereSalon, e)}
                                className="taille-input"
                            />
                        }
                    </div>
                    {
                    flagsSalon.length > 0 &&
                    (<div className="tableau-flags"><table>
                        <thead>
                            <tr>
                                <th scope="col">Salon</th>
                                <th scope="col">Modèle</th>
                                {flagsSalon.map(flag => (
                                    <th key={flag.Flag} className="nom-flag" title={flag.Nom}>
                                        {flag.Flag}
                                        <InfoIcone className={flag.Notes ? 'notes' : 'notes note-absente'} onClick={e => afficherNotes(flag)}/>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(salons).map(([index, salon]) =>
                                <tr key={salon.ID_Enseigne} className="ligne-activation">
                                    <td>{salon.ID_Enseigne}</td>
                                    <td>
                                        <Select
                                            placeholder="Modèle à appliquer"
                                            defaultValue={optionsModelesSalon.find(modele => modele.value === salon.Modele)}
                                            options={optionsModelesSalon}
                                            onChange={e => modifierModeleSalon(index, e)}
                                            className="flag-select"
                                        />
                                    </td>
                                    {flagsSalon.map(flag => (
                                        (flag.Valeurs_Proposees &&
                                            <td key={salon.ID_Enseigne + '_' + flag.Flag} className="cellule-activation">
                                                <div className="bloc-flag-select-salon">
                                                    <Select
                                                        value={optionsSelects[flag.Flag].find(option => option.value == salon[flag.Flag])}
                                                        options={optionsSelects[flag.Flag]}
                                                        onChange={e => modifierSelectFonctionnaliteSalon(index, flag.Flag, e)}
                                                        className="flag-select"
                                                    />
                                                    { (salon[flag.Flag] === undefined) &&
                                                        <Select
                                                            value={optionsSelects[flag.Flag].find(option => option.value == modelesSalon.find(modele => modele.ID_Enseigne === salon.Modele)[flag.Flag])}
                                                            options={optionsSelects[flag.Flag]}
                                                            onChange={e => {}}
                                                            isDisabled={true}
                                                            className="flag-select-modele"
                                                        />
                                                    }
                                                    { (salon[flag.Flag] !== undefined) &&
                                                        <AnnulerIcone className="annuler-flag-select" onClick={e => retourFlagModeleSalon(index, flag.Flag)}/>
                                                    }
                                                </div>
                                            </td>
                                        ) || (!flag.Valeurs_Proposees &&
                                            <td key={salon.ID_Enseigne + '_' + flag.Flag} className="cellule-activation">
                                                <Checkbox
                                                    checked={!!salon[flag.Flag]}
                                                    onChange={e => activerFonctionnaliteSalon(index, flag.Flag)}
                                                />
                                                { (salon[flag.Flag] === undefined) &&
                                                    <Checkbox
                                                        checked={!!modelesSalon.find(modele => modele.ID_Enseigne === salon.Modele)[flag.Flag]}
                                                        onChange={e => activerFonctionnaliteSalon(index, flag.Flag)}
                                                        className="flag-modele"
                                                        sx={{
                                                            color: '#CCCCCC',
                                                            '&.Mui-checked': {
                                                                color: '#CCCCCC',
                                                            },
                                                        }}
                                                    />
                                                }
                                                { (salon[flag.Flag] !== undefined) &&
                                                    <AnnulerIcone className="annuler-flag" onClick={e => retourFlagModeleSalon(index, flag.Flag)}/>
                                                }
                                            </td>
                                        )
                                    ))}
                                </tr>
                            )}
                        </tbody>
                    </table></div>)
                    }
                </div>
            </div>
            
            <div className={blocAdminOuvert ? 'bloc-fonctionnalites' : 'bloc-fonctionnalites ferme'}>
                <div className="ouvrir-fermer">
                    {!blocAdminOuvert && <FlecheDroite onClick={() => ouvrirBlocAdmin(true)}></FlecheDroite>}
                    {blocAdminOuvert && <FlecheBas onClick={() => ouvrirBlocAdmin(false)}></FlecheBas>}
                    Fonctionnalités admin
                </div>
                <div className="bloc-fonctionnel">
                    <h2>Fonctionnalités des modèles d'admin</h2>
                    {
                    flagsAdmin.length > 0 &&
                    (<div className="tableau-flags"><table>
                        <thead>
                            <tr>
                                <th scope="col">Modèle</th>
                                {flagsAdmin.map(flag => (
                                    <th key={flag.Flag} className="nom-flag" title={flag.Nom}>
                                        {flag.Flag}
                                        <InfoIcone className={flag.Notes ? 'notes' : 'notes note-absente'} onClick={e => afficherNotes(flag)}/>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(modelesAdmin).map(([index, modele]) =>
                                <tr key={modele.ID_Enseigne} className="ligne-activation">
                                    <td>{modele.Nom_Modele}</td>
                                    {flagsAdmin.map(flag => (
                                        <td key={modele.ID_Enseigne + '_' + flag.Flag} className="cellule-activation">
                                            { (flag.Valeurs_Proposees &&
                                                <Select
                                                    value={optionsSelects[flag.Flag].find(option => option.value == modele[flag.Flag])}
                                                    options={optionsSelects[flag.Flag]}
                                                    onChange={e => modifierSelectFonctionnaliteModele(index, flag.Flag, e, true)}
                                                    className={(modele[flag.Flag] === undefined) ? 'flag-manquant flag-select' : 'flag-select'}
                                                />
                                            ) || (!flag.Valeurs_Proposees &&
                                                <Checkbox
                                                    checked={!!modele[flag.Flag]}
                                                    onChange={e => activerFonctionnaliteModele(index, flag.Flag, true)}
                                                    className={(modele[flag.Flag] === undefined) ? 'flag-manquant' : ''}
                                                />
                                            )}
                                        </td>
                                    ))}
                                </tr>
                            )}
                        </tbody>
                    </table></div>)
                    }
                </div>
                <div className="bloc-fonctionnel">
                    <h2>Fonctionnalités des admins individuels</h2>
                    <div className="recherche-salon">
                        <h3>Recherche</h3>
                        <Select
                            placeholder="Critère"
                            value={critereAdmin}
                            options={listeCriteresAdmin}
                            onChange={modifierCritereAdmin}
                            className="taille-input"
                            menuPlacement={'top'}
                        />
                        { (critereAdmin.value === 'LOGIN') &&
                            <TextField onChange={event => rechercheParChaineAdmin(event.target.value)} className="taille-input"/>
                        }
                        { (critereAdmin.value === 'FLAG') &&
                            <Select
                                options={listeFlagsAdmin}
                                onChange={e => chercherSalon(critereAdmin, e, true)}
                                className="taille-input"
                                menuPlacement={'top'}
                            />
                        }
                        { (critereAdmin.value === 'MODELE') &&
                            <Select
                                options={optionsModelesAdmin}
                                onChange={e => chercherSalon(critereAdmin, e, true)}
                                className="taille-input"
                                menuPlacement={'top'}
                            />
                        }
                    </div>
                    {
                    flagsAdmin.length > 0 &&
                    (<div className="tableau-flags"><table>
                        <thead>
                            <tr>
                                <th scope="col">Admin</th>
                                <th scope="col">Modèle</th>
                                {flagsAdmin.map(flag => (
                                    <th key={flag.Flag} className="nom-flag" title={flag.Nom}>
                                        {flag.Flag}
                                        <InfoIcone className={flag.Notes ? 'notes' : 'notes note-absente'} onClick={e => afficherNotes(flag)}/>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(admins).map(([index, salon]) =>
                                <tr key={salon.ID_Enseigne} className="ligne-activation">
                                    <td>{salon.ID_Enseigne}</td>
                                    <td>
                                        <Select
                                            placeholder="Modèle à appliquer"
                                            defaultValue={optionsModelesAdmin.find(modele => modele.value === salon.Modele)}
                                            options={optionsModelesAdmin}
                                            onChange={e => modifierModeleAdmin(index, e)}
                                            className="flag-select"
                                            menuPlacement={'top'}
                                        />
                                    </td>
                                    {flagsAdmin.map(flag => (
                                        (flag.Valeurs_Proposees &&
                                            <td key={salon.ID_Enseigne + '_' + flag.Flag} className="cellule-activation">
                                                <div className="bloc-flag-select-salon">
                                                    <Select
                                                        value={optionsSelects[flag.Flag].find(option => option.value == salon[flag.Flag])}
                                                        options={optionsSelects[flag.Flag]}
                                                        onChange={e => modifierSelectFonctionnaliteAdmin(index, flag.Flag, e)}
                                                        className="flag-select"
                                                    />
                                                    { (salon[flag.Flag] === undefined) &&
                                                        <Select
                                                            value={optionsSelects[flag.Flag].find(option => option.value == modelesSalon.find(modele => modele.ID_Enseigne === salon.Modele)[flag.Flag])}
                                                            options={optionsSelects[flag.Flag]}
                                                            onChange={e => {}}
                                                            isDisabled={true}
                                                            className="flag-select-modele"
                                                        />
                                                    }
                                                    { (salon[flag.Flag] !== undefined) &&
                                                        <AnnulerIcone className="annuler-flag-select" onClick={e => retourFlagModeleAdmin(index, flag.Flag)}/>
                                                    }
                                                </div>
                                            </td>
                                        ) || (!flag.Valeurs_Proposees &&
                                            <td key={salon.ID_Enseigne + '_' + flag.Flag} className="cellule-activation">
                                                <Checkbox
                                                    checked={!!salon[flag.Flag]}
                                                    onChange={e => activerFonctionnaliteAdmin(index, flag.Flag)}
                                                />
                                                { (salon[flag.Flag] === undefined) &&
                                                    <Checkbox
                                                        disabled={!modelesAdmin.find(modele => modele.ID_Enseigne === salon.Modele)}
                                                        checked={!!modelesAdmin.find(modele => modele.ID_Enseigne === salon.Modele) && !!modelesAdmin.find(modele => modele.ID_Enseigne === salon.Modele)[flag.Flag]}
                                                        onChange={e => activerFonctionnaliteAdmin(index, flag.Flag)}
                                                        className="flag-modele"
                                                        sx={{
                                                            color: '#CCCCCC',
                                                            '&.Mui-checked': {
                                                                color: '#CCCCCC',
                                                            },
                                                        }}
                                                    />
                                                }
                                                { (salon[flag.Flag] !== undefined) &&
                                                    <AnnulerIcone className="annuler-flag" onClick={e => retourFlagModeleAdmin(index, flag.Flag)}/>
                                                }
                                            </td>
                                        )
                                    ))}
                                </tr>
                            )}
                        </tbody>
                    </table></div>)
                    }
                </div>
            </div>
            <Modal open={notesFlagOuvertes.Notes !== undefined} onClose={masquerNotes}>
                <Box className="pop-up">
                    <TextField multiline rows={4} defaultValue={notesFlagOuvertes.Notes} onChange={e => { saisieNotes = e.target.value; }}/>
                    <div className="boutons-pop-up">
                        <Button onClick={masquerNotes}>Fermer</Button>
                        <Button onClick={enregistrerNotes}>Modifier</Button>
                    </div>
                </Box>
            </Modal>
            <Modal open={nouveauSalonOuvert} onClose={_ => ouvrirNouveauSalon(false)}>
                <Box className="pop-up">
                    <div className="parametres-nouveau-salon">
                        <TextField placeholder="Login du salon (copier/coller)" onChange={e => setNouveauSalonLogin(e.target.value) }/>
                        <Select
                            placeholder="Modèle à appliquer"
                            options={optionsModelesSalon}
                            onChange={e => setNouveauSalonModele(e)}
                        />
                    </div>
                    <div className="boutons-pop-up">
                        <Button onClick={_ => ouvrirNouveauSalon(false)}>Annuler</Button>
                        <Button onClick={enregistrerNouveauSalon} disabled={!saisieNouveauSalonModele.value || saisieNouveauSalonLogin.length === 0}>Créer</Button>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default ActivationFonctionnalites;